<template>
  <div style="padding:20px;margin-bottom:50px;background-color:white">
    <!-- 연,월 -->
    <div class="flex-center" style="margin-bottom:8px">
      <div class="flex-align">
        <i class="material-icons icon-arrow unselect" @click="clickPrev">keyboard_arrow_left</i>
        <div class="lp-month">{{ `${this.currentDate.year()}년 ${this.currentDate.month()+1}월` }}</div>
        <i class="material-icons icon-arrow unselect" @click="clickNext">keyboard_arrow_right</i>
      </div>
    </div>
    <!-- 요일 -->
    <div class="flex lp-days">
      <div class="lp-day"
           v-for="(day,idx) in days" :key="'day-'+idx">{{ day }}</div>
    </div>
    <!-- 일 -->
    <div class="flex wrap lp-dates">
      <div class="lp-date unselect"
           v-for="(date,idx) in dates" :key="'date-'+idx"
           @click="clickDate(date,idx)">
        <!-- 일자 표시 -->
        <div :style="dayStyle(date)" @click="clickDate(date)">{{ date.day > 0 ? date.day : '' }}</div>
      </div>
    </div>

    <!-- 예약 일정 -->
    <div class="grid-box box-resv" v-for="(resv,idx) in resvs" :key="'resv-'+idx">
      <div class="col-6">
        <div :style="brandColor.main" style="margin-bottom:4px" class="size-14">{{ `${resv.start_time} ~ ${resv.end_time}`}}</div>
        <div :style="brandColor.sub" class="size-12">{{ `${resv.remain} / ${resv.stock}` }}</div>
      </div>
      <div class="col-6 flex-end">
        <div>
          <div class="flex-end">
            <div :style="btnStyle(resv)" class="unselect size-14" @click="clickResv(resv)">{{ resv.remain === 0 ? '마감' : '선택' }}</div>
          </div>
          <div class="flex-align" v-if="resv.selected">
            <div :style="brandColor.main" class="size-14" style="margin-right:12px">수량</div>
            <quantity-input
              :inputStyle="{border:0,width:'40px',textAlign:'center'}"
              :btnMinusStyle="btnMinusStyle"
              :btnPlusStyle="btnPlusStyle"
              :max="max"
              :value.sync="ordered_count"></quantity-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import moment from 'moment';
  import QuantityInput from "@/components/module/common/QuantityInput";
  export default {
    name: 'BlockResv',
    components: {
      QuantityInput

    },
    mixins: [

    ],
    props: {
      product_id: {
        type: Number
      }
    },
    data() {
      return {
        "max": 1,
        "days": [
          "일",
          "월",
          "화",
          "수",
          "목",
          "금",
          "토"
        ],
        "dates": [],
        "resvs": [],
        "currentDate": undefined,
        "selectedResv": undefined,
        "ordered_count": 1,
        brandColor: {
          main: {
            color: '#000000'
          },
          brand: {
            color: '#ff5722'
          },
          sub: {
            color: '#bbbbbb'
          }
        },
        brandBgColor: {
          main: {
            backgroundColor: '#ffffff'
          },
          brand: {
            backgroundColor: '#ff5722'
          },
          sub: {
            backgroundColor: '#eeeeee'
          }
        },
        brandBorder: {
          main: {
            border: '1px solid #dddddd'
          },
          brand: {
            border: '1px solid #ff5722'
          }
        }
      }
    },
    created() {
      this.currentDate = moment();
      this.setDates();
    },

    methods: {
      resvStr() {
        if(this.selectedResv)
          return `${this.datesFormat(this.selectedResv.date, 'date_5')} ${this.selectedResv.time} ${this.selectedResv.ordered_count}명 예약`;
        else
          return '';
      },
      clickOk() {
        this.selectedResv.product_id = this.product_id;
        this.selectedResv.ordered_count = this.ordered_count;
        this.selectedResv.resvStr = this.resvStr();
        this.$emit('clickReserve', this.selectedResv);
      },
      clickResv(resv) {
        if(resv.remain === 0) return;

        this.ordered_count = 1;
        this.max = resv.remain;

        this.resvs.forEach(item => {
          item.selected = false;
        });
        resv.selected = true;
        let date = this.dates.filter(date => {
          return date.selected;
        })[0];
        this.selectedResv = {
          date: '%4d-%02d-%02d'.format(date.year, date.month, date.day),
          time: `${resv.start_time} ~ ${resv.end_time}`,
          start_time: resv.start_time,
          end_time: resv.end_time
        };

        this.clickOk();
      },
      clickDate(date) {
        if(!date.enable || date.prev) {
          return;
        }
        this.dates.forEach(date => { date.selected = false; });
        date.selected = true;
        this.resvs = date.times;
        this.resvs.forEach(item => {
          item.selected = false;
        });
        this.selectedResv = undefined;
      },
      clickNext() {
        this.currentDate.add(1, 'months');
        this.setDates();
      },
      clickPrev() {
        this.currentDate.subtract(1, 'months');
        this.setDates();
      },
      btnStyle(resv) {
        let deco = {
          borderRadius: '20px',
          padding: '5px 20px',
          textAlign: 'center',
          marginBottom: '12px'
        };
        if(resv.remain === 0) {
          deco.color = 'white';
          deco.backgroundColor = '#ddd';
        }
        else {
          if(resv.selected) {
            deco.color = 'white';
            deco.backgroundColor = this.brandBgColor.brand.backgroundColor;
          } else {
            deco.color = this.brandColor.brand.color;
          }
          deco.border = this.brandBorder.brand.border;
        }

        return deco;
      },
      dayStyle(date) {
        let deco = {
          borderRadius: '50%',
          color: 'white',
          width: '36px',
          height: '36px',
          lineHeight: '36px',
          textAlign: 'center'
        };

        if(date.prev) {
          deco.border = '1px solid #dddddd';
          deco.color = '#e4dde4';
          deco.lineHeight = '35px';
        }
        else if(!date.enable) {
          deco.backgroundColor = '#dddddd';
          deco.color = 'white';
        }
        else if(date.selected) {
          deco.backgroundColor = this.brandBgColor.brand.backgroundColor;
          deco.color = 'white';
        }
        else {
          deco.color = '#515151';
          deco.border = '1px solid #dddddd';
          deco.lineHeight = '35px';
        }
        deco.fontSize = '13px';

        return deco;
      },
      setDates() {
        this.selectedResv = undefined;
        this.resvs = [];
        this.dates = [];
        let day = 0;
        let year = this.currentDate.year();
        let month = this.currentDate.month()+1;
        let start_day = this.currentDate.startOf('month').day();
        let end_date = this.currentDate.endOf('month').date();
        let len = 42;
        if(start_day + end_date <= 35) {
          len = 35;
        }

        // 이전달 날짜
        for(let i=start_day-1; i>=0; i--) {
          let old = moment(this.currentDate);
          old.subtract(1, 'month');
          let old_last = old.endOf('month').date();

          this.dates.push({
            year: old.year(),
            month: old.month()+1,
            day: old_last - i,
            prev: true
          });
        }

        for(let i=0; i< len; i++) {
          if(i>=start_day && day<end_date) {
            let date = {
              year: year,
              month: month,
              day: ++day,
              enable: false,
            };
            date.prev = moment('%d-%02d-%02d'.format(year,month,day+1)).isBefore(moment());

            this.dates.push(date);
          }
        }

        // 다음달 날짜
        for(let i=1; i<=(len-end_date-start_day); i++) {
          let next = moment(this.currentDate);
          next.add(1, 'month');

          this.dates.push({
            year: next.year(),
            month: next.month()+1,
            day: i,
            prev: true
          });
        }

        let date = `${this.currentDate.year()}-${this.currentDate.month()+1}`;

        let url = `public/product/${this.product_id}/schedule/monthly/${date}`;

        this.$axios.get(url).then(res => {
          res.data.dates.forEach(item => {
            if(item.day>0 && item.times.length>0) {
              item.times = item.times.filter(time => {
                return !time.break_time
              });

              item.times.forEach(item => {
                item.selected = false;
              });
              let date = this.dates.filter(date => {
                return date.year === item.year &&
                  date.month === item.month &&
                  date.day === item.day;
              })[0];
              date.enable = true;
              date.times = item.times;

            }
          });

        });
      }
    },
    computed: {
      btnMinusStyle() {
        return {
          fontSize:'20px',
          borderRadius:'50%',
          border: this.brandBorder.main.border,
          color: this.brandColor.sub.color
        };
      },
      btnPlusStyle() {
        return {
          fontSize:'20px',
          borderRadius:'50%',
          border: this.brandBorder.brand.border,
          color: this.brandColor.brand.color
        };
      }
    },
    watch: {
      ordered_count() {
        this.clickOk();
      }
    }
  }
</script>
<style scoped>
  .lp-month {
    font-size: 15px;
    margin: 0 12px;
  }
  .lp-days {
    padding: 12px 0;
    border-bottom: 1px solid #ddd;
    margin-bottom: 12px;
  }
  .lp-day {
    width: 14.2857%;
    text-align: center;
    padding-bottom: 4px;
    font-size: 13px;
  }
  .lp-dates {
    margin-bottom: 20px;
  }
  .lp-date {
    width: 14.2857%;
    display: flex;
    justify-content: center;
    padding: 8px 0;
  }
  .icon-arrow {
    color: #fff;
    background-color: #777;
    border-radius: 50%;
    font-size: 18px;
  }
  .box-resv {
    padding: 12px 0;
    border-top: 1px solid #ddd;
  }
  .flex-align {
    display: flex;
    align-items: center;
  }
  .flex-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .flex-end {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .grid-box {
    display: flex;
    flex-wrap: wrap;
  }
  .col-1 {
    width: 8.33333%;
  }
  .col-2 {
    width: 16.6667%;
  }
  .col-3 {
    width: 25%;
  }
  .col-4 {
    width: 33.3333%;
  }
  .col-5 {
    width: 41.6667%;
  }
  .col-6 {
    width: 50%;
  }
  .col-7 {
    width: 58.3333%;
  }
  .col-8 {
    width: 66.6667%;
  }
  .col-9 {
    width: 75%;
  }
  .col-10 {
    width: 83.3333%;
  }
  .col-11 {
    width: 91.6667%;
  }
  .col-12 {
    width: 100%;
  }

</style>
